<template>
    <v-container no-gutters class="mx-0 px-0" fluid>
        <v-form class="mx-0 px-0" @submit.prevent="submit">
            <v-row justify="center" align="center" class="mx-0 px-0">
                <v-col cols=12 align=center class="mx-0 px-0">
                    <v-text-field
                        v-model.trim="email"
                        :rules="[rules.email]"
                        label="Email"
                        type="email"
                        autocomplete="username"
                        class="email"
                        outlined
                        required
                    />
                </v-col>
            </v-row>
            <v-row justify="center" align="center" class="mx-0 px-0">
                <v-col cols=12 align="center" class="mx-0 px-0">
                    <v-text-field
                        v-model="password"
                        :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
                        :type="show ? 'text' : 'password'"
                        label="Κωδικός"
                        autocomplete="current-password"
                        class="password"
                        outlined
                        @click:append="show = !show"
                    />
                </v-col>
            </v-row>
            <v-row justify="center" align="center" class="mx-0 px-0">
                <v-col cols=12 align="center" class="mx-0 px-0">
                    <v-alert v-if="error" type="error" text dense>{{ error }}</v-alert>
                    <div class="submit-button-wrapper">
                        <v-btn
                            class="white--text"
                            color="#1b2f5a"
                            type="submit"
                            depressed
                            block
                            x-large
                            :loading="loading"
                            :disabled="shouldDisableSubmit()"
                        >
                            Είσοδος
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
    import userService from '@/services/user'
    export default {
        data() {
            return {
                show: false,
                loading: false,
                rules: {
                    email: value => {
                        return this.validEmailForm(value) || 'Μη έγκυρη διεύθυνση email'
                    }
                },
                email: '',
                password: '',
                error: null
            }
        },
        methods: {
            shouldDisableSubmit() {
                if (!this.validEmailForm(this.email) || this.password === '') {
                    return true
                }
                return false
            },
            validEmailForm(email) {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(email)
            },
            submit() {
                if (this.shouldDisableSubmit() || this.loading) {
                    return
                }
                this.error = null
                this.loading = true
                userService.login({
                    username: this.email,
                    password: this.password
                }).then(resp => {
                    // this login is for dealers; administrators use the admin panel
                    if (!resp || resp.role !== 'dealer') {
                        this.error = 'Αυτός ο λογαριασμός δεν έχει πρόσβαση εδώ.'
                        return
                    }
                    return this.$store.dispatch('clearSession')
                        .then(() => this.$store.dispatch('login', resp))
                        .then(() => this.$router.push({name: 'Profile'}))
                }).catch(error => {
                    const status = error.response && error.response.status
                    this.error = status === 401
                        ? 'Λάθος email ή κωδικός.'
                        : 'Δεν ήταν δυνατή η σύνδεση. Δοκιμάστε ξανά σε λίγο.'
                }).finally(() => {
                    this.loading = false
                })
            }
        }
    }
</script>